import { useMutation } from '@tanstack/react-query';

import { fetchListOneApi } from '../api';

export default function useListOneMutation(options?: any) {
  return useMutation(fetchListOneApi, options);
}
